import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../../hotel.service';

@Component({
  selector: 'app-hotel-accomodation-filter',
  templateUrl: './hotel-accomodation-filter.component.html',
  styleUrls: ['./hotel-accomodation-filter.component.scss']
})
export class HotelAccomodationFilterComponent implements OnInit {
    isCollapsed = false;
    protected subs = new SubSink();
    hotelsCopy: any;
    uniqueAccommodationCodes: any[] = [];
    selectedAccommodationCodes: string[] = []; // Array to store selected accommodation codes
  
    constructor(private hotelService: HotelService, private cdr: ChangeDetectorRef) { }
  
    ngOnInit(): void {
      this.subs.sink = this.hotelService.hotelsCopy.subscribe(res => {
        if (res.length) {
          this.hotelsCopy = res;
          this.uniqueAccommodationCodes = this.getUniqueAccommodationCodes(res);
        } else {
          this.hotelsCopy = [];
        }
        this.cdr.detectChanges();
      });
    }
  

    getUniqueAccommodationCodes(hotels) {
      const accommodationCodes = hotels.map(hotel => hotel.AccommodationCode);

      return Array.from(new Set(accommodationCodes));
    }
  
  
    onAccommodationChange(accommodationCode: string, isChecked: boolean) {
      // Get the current value (array) of selectedAccommodationCodes
      let currentAccommodationCodes = this.hotelService.selectedAccommodationCodes.getValue();
    
      if (isChecked) {
        // Add the selected accommodation code if it's not already in the array
        if (!currentAccommodationCodes.includes(accommodationCode)) {
          currentAccommodationCodes.push(accommodationCode);
        }
      } else {
        // Remove the accommodation code if unchecked
        currentAccommodationCodes = currentAccommodationCodes.filter(code => code !== accommodationCode);
      }
    
      // Update the BehaviorSubject with the modified array
      this.hotelService.selectedAccommodationCodes.next(currentAccommodationCodes);
    
      // Trigger filter update based on the current selection
      this.applyFilters();
    }
    
  
    applyFilters() {
      this.hotelService.setHotelAccomodation(); 
    }
  
}
